<div mat-dialog-title class="title-text" translate>ADVANCED_FUNCTION_DIALOG.TITLE</div>
<div mat-dialog-content>
    <div [innerHTML]="'ADVANCED_FUNCTION_DIALOG.MESSAGE' | translate"></div>

    <div class="content-container">
        <img src="../../../../assets/call.png" alt="logo" class="support-image">
        <div class="time-table-container">
            <div translate>
                ADVANCED_FUNCTION_DIALOG.TIME_TABLE_1
            </div>
            <div translate>
                ADVANCED_FUNCTION_DIALOG.TIME_TABLE_2
            </div>
            <div translate>
                ADVANCED_FUNCTION_DIALOG.TIME_TABLE_3
            </div>
        </div>
    </div>
</div>
<div mat-dialog-actions>
    <button mat-flat-button cdkFocusInitial (click)="dialogRef.close()" translate>
        <div translate>OK</div>
    </button>
</div>